import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur-sm border-b border-background-200">
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-2xl font-bold font-heading text-accent-500">黑料</span>
          <span className="text-2xl font-bold font-heading text-foreground-950">bu</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            首页
          </Link>
          <Link to="/category/mingxing" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            明星黑料
          </Link>
          <Link to="/category/wanghong" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            网红黑料
          </Link>
          <Link to="/category/dawei" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            大V黑料
          </Link>
          <Link to="/category/zuixin" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            最新爆料
          </Link>
          <Link to="/category/chiigua" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            热点吃瓜
          </Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors">
            关于我们
          </Link>
        </div>

        <div className="md:hidden flex items-center">
          <Link to="/category/zuixin" className="text-sm font-medium text-accent-500 whitespace-nowrap">
            最新爆料
          </Link>
        </div>
      </nav>
    </header>
  );
}